import { render, staticRenderFns } from "./DefectMonitors.vue?vue&type=template&id=1bf90750&scoped=true&"
import script from "./DefectMonitors.vue?vue&type=script&lang=js&"
export * from "./DefectMonitors.vue?vue&type=script&lang=js&"
import style0 from "./DefectMonitors.vue?vue&type=style&index=0&id=1bf90750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf90750",
  null
  
)

export default component.exports